// 11 §8 — server-offset clock. `Date.now` is allowed only here (18.1 lint); every timer
// renders `deadlineAt − serverNow()` and never raw device time.

let offsetMs = 0;          // serverNow = deviceNow + offsetMs
let lastSyncAt = 0;

export function deviceNow(): number { return Date.now(); }

/** Called with the server timestamp the SDK reports on the first subscription applied, refreshed every 60 s. */
export function syncServerTime(serverTimestampMs: number, roundTripMs = 0): void {
  offsetMs = serverTimestampMs + roundTripMs / 2 - deviceNow();
  lastSyncAt = deviceNow();
}

export function serverOffsetMs(): number { return offsetMs; }
export function serverNow(): number { return deviceNow() + offsetMs; }

// Every heartbeat re-estimates the offset from one round trip, so it hops by tens of ms each
// time; a walk drawn from `serverNow` hopped with it. Motion reads this one instead: it slews
// towards the latest offset at no more than a tenth of real time, and only jumps when far out.
let smoothOffset: number | undefined;
let smoothAt = 0;
const SLEW = 0.1, SNAP_MS = 2000;
/** `serverNow` without the resync hops, for anything that moves (walks on the maps). */
export function smoothServerNow(): number {
  const now = deviceNow();
  if (smoothOffset === undefined || Math.abs(offsetMs - smoothOffset) > SNAP_MS) smoothOffset = offsetMs;
  else { const step = Math.max(0, now - smoothAt) * SLEW; smoothOffset += Math.max(-step, Math.min(step, offsetMs - smoothOffset)); }
  smoothAt = now;
  return now + smoothOffset;
}
export function lastSyncAgeMs(): number { return lastSyncAt ? deviceNow() - lastSyncAt : Number.POSITIVE_INFINITY; }

/** Whole seconds remaining to `deadlineAt` (server ms), clamped at 0. */
export function secondsUntil(deadlineAt: number, now = serverNow()): number {
  return Math.max(0, Math.ceil((deadlineAt - now) / 1000));
}

export function formatMmSs(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const mm = Math.floor(s / 60);
  const ss = s % 60;
  return `${String(mm).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
}
